import { z } from 'zod';

export const chatProfileSchema = z.object({
  /** Empty shows the member's first name. */
  displayName: z.string().trim().max(60, { error: 'chatSettings:validation.max60' }),
  avatarMediaId: z.string().nullable(),
});

export type ChatProfileForm = z.infer<typeof chatProfileSchema>;
